module.exports = __webpack_public_path__ + "static/fonts/Nunito-SemiBold.bbae15b.woff2";